import { Box, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts';
import { useEntitlements, type FeatureKey } from '@/services/subscription';
import { hasPermission } from '@/utils/roleAccess';

type Item = { path: string; ar: string; en: string; permission: string; feature?: FeatureKey };
const groups: Record<string, Item[]> = {
  purchasing: [
    { path: '/purchasing/orders', ar: 'أوامر الشراء', en: 'Purchase orders', permission: 'purchasing.orders.read' },
    { path: '/purchasing/invoices', ar: 'فواتير المشتريات', en: 'Purchase invoices', permission: 'purchasing.invoices.read' },
  ],
  inventory: [
    { path: '/inventory', ar: 'المخزون', en: 'Stock overview', permission: 'inventory.read' },
    { path: '/inventory/movements', ar: 'حركات المخزون', en: 'Stock movements', permission: 'inventory.read' },
    { path: '/inventory/counts', ar: 'جرد المخزون', en: 'Inventory counts', permission: 'inventory.read' },
  ],
  accounting: [
    { path: '/accounting', ar: 'دليل الحسابات', en: 'Chart of accounts', permission: 'accounting.gl_accounts.read', feature: 'accounting' },
    { path: '/accounting/journal-entries', ar: 'القيود اليومية', en: 'Journal entries', permission: 'accounting.journal_entries.read', feature: 'accounting' },
    { path: '/accounting/reports', ar: 'التقارير المحاسبية', en: 'Accounting reports', permission: 'accounting.reports', feature: 'accounting' },
    { path: '/reports/financial', ar: 'التقرير المالي', en: 'Financial report', permission: 'reporting.financial.read', feature: 'advanced_reports' },
  ],
};
export function ModuleNavigation() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const { data } = useEntitlements();
  const group = pathname === '/reports/financial' ? 'accounting' : pathname.split('/')[1] ?? '';
  const items = (groups[group] ?? []).filter(item => hasPermission(user?.permissions, item.permission) && (!item.feature || data?.features[item.feature] !== false));
  if (!items.length) return null;
  const active = [...items].sort((a, b) => b.path.length - a.path.length).find(item => pathname === item.path || pathname.startsWith(`${item.path}/`))?.path;
  return <Box component="nav" aria-label={i18n.language.startsWith('ar') ? 'تنقل الوحدة' : 'Module navigation'} sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
    {items.map(item => <Button component={Link} key={item.path} to={item.path} variant={active === item.path ? 'contained' : 'text'} aria-current={active === item.path ? 'page' : undefined}>{i18n.language.startsWith('ar') ? item.ar : item.en}</Button>)}
  </Box>;
}
